import pipe from 'ramda/es/pipe'
import toPairs from 'ramda/es/toPairs'
import fromPairs from 'ramda/es/fromPairs'
import filter from 'ramda/es/filter'

export default (obj: any): any => pipe(
  filter<any, 'array'>((entry: any) => !!entry[1]),
  fromPairs,
)(toPairs(obj))
